import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cash-payment-print',
  templateUrl: './cash-payment-print.component.html',
  styleUrls: ['./cash-payment-print.component.css']
})
export class CashPaymentPrintComponent implements OnInit {
  FilterModel = {
    FromDate: '',
    ToDate: '',
    Print:""
}
  TransID=0;
  constructor(private activatedRoute:ActivatedRoute,private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { 
    this.activatedRoute.queryParams.subscribe(params => {
     
      this.FilterModel.FromDate =  params['FromDate'];
      this.FilterModel.ToDate =  params['ToDate'];
      this.FilterModel.Print = "P";
      this.GetCashPayment()
  });
  }
  loadingSearch = false;
  CashpaymentList:any;
  BranchDetails:any;
 GetCashPayment  () {
     this.loadingSearch = true;
     this.spinnerService.show();
      this.accService.GetCashPayment(JSON.stringify(this.FilterModel)).subscribe( (data)=> {
        this.CashpaymentList = data.CashpaymentList;
        this.BranchDetails = data.BranchDetails;
        this.spinnerService.hide();
        if (this.CashpaymentList.length > 0) {
            this.search(this.CashpaymentList);
        }


        setTimeout(()=> {
            window.print();
        }, 200);
      });
  };
  itemsPerPage=10;
  pagedItems = [];
 search(itemlist){
   
  for (var i = 0; i < itemlist.length; i++) {
      if (i % this.itemsPerPage === 0) {
        this.pagedItems[Math.floor(i / this.itemsPerPage)] = [itemlist[i]];
      } else {
        this.pagedItems[Math.floor(i / this.itemsPerPage)].push(itemlist[i]);
      }
  }
}
GetTotalAmountCredit  (StudentFeeDetailsList) {
  var sum = 0;
  for (var i = 0; i < StudentFeeDetailsList.length; i++) {
      sum = sum + StudentFeeDetailsList[i].CreditAmt;
  }

  return this.globalHelper.Decimal(sum);

}
GetTotalAmountDebit  (StudentFeeDetailsList) {
  var sum = 0;
  for (var i = 0; i < StudentFeeDetailsList.length; i++) {
      sum = sum + StudentFeeDetailsList[i].DebitAmt;
  }

  return this.globalHelper.Decimal(sum);

}
  PrintDate:any;
  ngOnInit() {
    this.PrintDate = new Date();
  }

}
